import MultipleChoiceExamDetail from './containers/MultipleChoiceExamDetail';
import ExtractFileTextError from './components/ExtractFileTextError';
import RecruitingInterview from './containers/RecruitingInterview';
import CodingExamDetail from './containers/CodingExamDetail';
import { usePostJob } from '../../../hooks/usePostJob';
import SubmittingJob from './components/SubmittingJob';
import ExamDeadline from './containers/ExamDeadline';
import Stepper from '../../../components/Stepper';
import JobDetail from './containers/JobDetail';
import Approval from './containers/Approval';
import styles from './style.module.scss';
import Review from './containers/Review';

function PostJob() {
    const {
        step,
        city,
        state,
        files,
        cities,
        states,
        country,
        jobType,
        posting,
        jobTitle,
        countries,
        deadline,
        stepCount,
        codingExam,
        salaryAmount,
        workplaceType,
        jobDescription,
        salaryFrequency,
        multipleChoiceExam,
        setMultipleChoiceExam,
        codingExamLanguages,
        fetchingJobDescription,
        multipleChoiceExamSkills,
        multipleChoiceCodingExam,
        multipleChoiceCodingExamLanguages,
        submit,
        setCity,
        setStep,
        setState,
        setCountry,
        setJobType,
        fileSelect,
        removeFile,
        setJobTitle,
        setDeadline,
        updateSkills,
        setCodingExam,
        setCityAndState,
        setSalaryAmount,
        setWorkplaceType,
        setJobDescription,
        setSalaryFrequency,
        recruitingInterview,
        setRecruitingInterview,
        getJobDescriptionFromAI,
        updateCodingExamLanguages,
        setMultipleChoiceExamSkills,
        setMultipleChoiceCodingExam,
        updateMultipleChoiceCodingLanguages,
        setMultipleChoiceCodingExamLanguages,
        selectedInterviewQuestions,
        setSelectedInterviewQuestions,
        defaultInterviewQuestions,
        setDefaultInterviewQuestions,
        resetInterviewToDefault,
        resumeMatching,
        setResumeMatching,
        extractFileTextErrorModal,
        submittingJobModal,
    } = usePostJob();

    return (
        <div className={styles.container}>
            {step !== 'Approval' && <Stepper step={5} current={stepCount} />}

            {step === 'JobDetail' && <JobDetail
                city={city}
                state={state}
                states={states}
                cities={cities}
                setStep={setStep}
                jobType={jobType}
                setCity={setCity}
                country={country}
                setState={setState}
                jobTitle={jobTitle}
                countries={countries}
                setJobType={setJobType}
                setCountry={setCountry}
                setJobTitle={setJobTitle}
                salaryAmount={salaryAmount}
                workplaceType={workplaceType}
                setCityAndState={setCityAndState}
                setSalaryAmount={setSalaryAmount}
                salaryFrequency={salaryFrequency}
                setWorkplaceType={setWorkplaceType}
                setSalaryFrequency={setSalaryFrequency}
            />}

            {step === 'RecruitingInterview' && <RecruitingInterview
                setStep={setStep}
                resetToDefault={resetInterviewToDefault}
                recruitingInterview={recruitingInterview}
                defaultQuestions={defaultInterviewQuestions}
                selectedQuestions={selectedInterviewQuestions}
                setRecruitingInterview={setRecruitingInterview}
                setDefaultQuestions={setDefaultInterviewQuestions}
                setSelectedQuestions={setSelectedInterviewQuestions}
            />}

            {step === 'MultipleChoiceExamDetail' && <MultipleChoiceExamDetail
                setStep={setStep}
                updateSkills={updateSkills}
                multipleChoiceExam={multipleChoiceExam}
                setMultipleChoiceExam={setMultipleChoiceExam}
                multipleChoiceExamSkills={multipleChoiceExamSkills}
                multipleChoiceCodingExam={multipleChoiceCodingExam}
                setMultipleChoiceExamSkills={setMultipleChoiceExamSkills}
                setMultipleChoiceCodingExam={setMultipleChoiceCodingExam}
                multipleChoiceCodingExamLanguages={multipleChoiceCodingExamLanguages}
                updateMultipleChoiceCodingLanguages={updateMultipleChoiceCodingLanguages}
                setMultipleChoiceCodingExamLanguages={setMultipleChoiceCodingExamLanguages}
            />}

            {step === 'CodingExamDetail' && <CodingExamDetail
                setStep={setStep}
                codingExam={codingExam}
                setCodingExam={setCodingExam}
                codingExamLanguages={codingExamLanguages}
                updateCodingExamLanguages={updateCodingExamLanguages}
            />}

            {step === 'ExamDeadline' && <ExamDeadline
                files={files}
                setStep={setStep}
                deadline={deadline}
                fileSelect={fileSelect}
                removeFile={removeFile}
                setDeadline={setDeadline}
                resumeMatching={resumeMatching}
                setResumeMatching={setResumeMatching}
                jobDescription={jobDescription}
                setJobDescription={setJobDescription}
                fetchingJobDescription={fetchingJobDescription}
                getJobDescriptionFromAI={getJobDescriptionFromAI}
            />}

            {(step === 'Review' || step === 'Approval') && <Review
                city={city}
                state={state}
                submit={submit}
                setStep={setStep}
                posting={posting}
                jobType={jobType}
                country={country}
                deadline={deadline}
                jobTitle={jobTitle}
                codingExam={codingExam}
                salaryAmount={salaryAmount}
                workplaceType={workplaceType}
                resumeMatching={resumeMatching}
                jobDescription={jobDescription}
                salaryFrequency={salaryFrequency}
                multipleChoiceExam={multipleChoiceExam}
                recruitingInterview={recruitingInterview}
                selectedQuestions={selectedInterviewQuestions}
                codingExamLanguages={codingExamLanguages}
                multipleChoiceCodingExam={multipleChoiceCodingExam}
                multipleChoiceExamSkills={multipleChoiceExamSkills}
                multipleChoiceCodingExamLanguages={multipleChoiceCodingExamLanguages}
            />}

            {/* {step === 'Approval' && <Approval />} */}
            {submittingJobModal && <SubmittingJob />}
            {extractFileTextErrorModal && <ExtractFileTextError />}
        </div>
    )
};

export default PostJob;
